<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Gestionar valoraciones</strong>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <a-divider orientation="left"><strong>Lista de Valoraciones</strong>
              <b-button variant="primary" @click="openModal(null)" style="position: absolute; right: 2rem; top: -0.5em; z-index: 1;">Crear</b-button>
            </a-divider>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <a-table v-if="data.length > 0" :columns="columns" :dataSource="data" rowKey="id">
                <div slot="system" slot-scope="type">
                  {{ type.name }}
                </div>
                 <div slot="action" slot-scope="level">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Editar</span>
                    </template>
                    <button type="button" @click="() => openModal(level)" class="btn btn-light mr-2">
                      <i class="fa fa-edit" />
                    </button>
                  </a-tooltip>
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Gestionar Rangos</span>
                    </template>
                    <button type="button" @click="() => openModalRange(level)" class="btn btn-light mr-2">
                      <i class="fa fa-list-alt" />
                    </button>
                  </a-tooltip>
                </div>
              </a-table>
              <empty-table v-else/>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="md" id="assesment" ref="modal" :title="form.isEditing ? 'Actualizar valoración' : 'Crear valoración'" hide-footer @hidden="onHidden">
      <b-row>
        <b-col lg="6">
          <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-1" description="Ejemplo: Númerico">
            <b-form-input id="input-1-edit" v-model="form.name" required placeholder="Ingrese el nombre"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group id="input-group-2-edit" label="Tipo:" label-for="input-2" description="Ejemplo: 2">
            <b-form-select v-model="form.idQualificationSystem" :options="systemsAvailable" required></b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group id="input-group-3-edit" label="Min:" label-for="input-3" description="Ejemplo: 1">
            <b-form-input id="input-3-edit" v-model="form.min" required placeholder="Ingrese el valor"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group id="input-group-4-edit" label="Max:" label-for="input-4" description="Ejemplo: 5">
            <b-form-input id="input-4-edit" v-model="form.max" required placeholder="Ingrese el valor"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="6" v-show="showDecimalOptions">
          <b-form-group id="input-group-6-edit" label="Número de décimales:" label-for="input-6" description="Ejemplo: 1">
            <b-form-input id="input-6-edit" v-model="form.assessment.decimal" required placeholder="Ingrese el valor"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="6" v-show="showDecimalOptions">
          <b-form-group id="input-group-7-edit" label="Aproximar:" label-for="input-7" description="Ejemplo: 5">
            <b-form-checkbox v-model="form.assessment.approximate" name="input-7" switch />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col lg="5" align-self="end">
          <b-button @click="save()" variant="primary" class="mb-3 mt-3">{{ form.isEditing ? 'Actualizar' : 'Guardar' }}</b-button>
          <b-button @click="$bvModal.hide('level')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal size="lg" id="range" ref="modal" title="Actualizar Rangos" hide-footer @hidden="onHidden">
      <b-row>
        <b-col>
          <b-collapse id="collapse-1" class="mt-2" v-model="visibleCollapse">
            <b-card>
              <validation-observer ref="rangeObserver" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(saveRange())">
                  <b-row>
                    <b-col lg="6">
                      <b-form-group id="input-group-1-range" label="Nombre:" label-for="input-1-range" description="Ejemplo: Númerico">
                        <b-form-input id="input-1-range" v-model="formRange.name" required placeholder="Ingrese el nombre"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6" v-if="checkEvaluationSystem(form.idQualificationSystem, 'QUALITATIVE')">
                      <b-form-group id="input-group-2-range" label="Abreviación:" label-for="input-2-range" description="Ejemplo: A">
                        <b-form-input id="input-2-range" v-model="formRange.abbreviation" required placeholder="Ingrese el nombre"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6">
                      <validation-provider
                        name="rangeStart"
                        :rules="{ required: true, double:true, min_value: form.min, max_value: form.max }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-3-range" label="Inicio:"
                          label-for="input-3-range" description="Ejemplo: 0"
                          :invalid-feedback="getValidationMessage(formRange.start)"
                        >
                          <b-form-input id="input-3-range" type="number" step="any" :min="form.min" :max="form.max" v-model="formRange.start"
                            :state="getValidationState(validationContext)" required placeholder="Ingrese el valor" autocomplete="off"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col lg="6">
                      <validation-provider
                        name="rangeEnd"
                        :rules="{ required: true, double: true, min_value: form.min, max_value: form.max }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-4-range" label="Final:"
                          label-for="input-4-range" description="Ejemplo: 2"
                          :invalid-feedback="getValidationMessage(formRange.end)"
                        >
                          <b-form-input id="input-4-range" type="number" step="any" :min="form.min" :max="form.max" v-model="formRange.end"
                            :state="getValidationState(validationContext)" required placeholder="Ingrese el valor" autocomplete="off"></b-form-input>
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                    <b-col lg="6">
                      <b-form-group id="input-group-5-range" label="Orden:" label-for="input-5-range" description="Orden de visualización">
                        <b-form-select v-model="formRange.order" :options="orderAvailable" required name="input-5-range"></b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="6">
                      <b-form-group id="input-group-6-range" label="Pierde:" label-for="input-6-range" description="Si el estudiante pierde con esta calificación">
                        <b-form-checkbox v-model="formRange.lose" name="input-6-range" switch />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-button variant="primary" type="submit">{{ formRange.isEditing ? 'Guardar edición' : 'Guardar'}}</b-button>
                  <b-button variant="light" class="btn-sm" @click="onHiddenAssesmentRanges()">Cancelar</b-button>
                </b-form>
              </validation-observer>
            </b-card>
          </b-collapse>
          <b-collapse id="collapse-2" class="mt-2" v-model="visibleCollapse2">
            <b-card>
              <validation-observer ref="rangeObserver" v-slot="{ handleSubmit }">
                <b-form @submit.prevent="handleSubmit(saveRange())">
                  <b-row>
                    <b-col>
                      <validation-provider
                        name="description"
                        :rules="{ required: true }"
                        v-slot="validationContext"
                      >
                        <b-form-group id="input-group-9-description" label="Descripción:" label-for="input-9-description"
                          description="Ejemplo: El estudiante muestra poco o ningún dominio del criterio (yo puedo) y a pesar del constante apoyo y seguimiento no alcanza los objetivos propuestos">
                          <b-form-textarea
                            id="input-9-description"
                            v-model="formRange.description"
                            placeholder="Breve descripción..."
                            :state="getValidationState(validationContext)"
                            rows="3"
                            max-rows="6"
                          />
                        </b-form-group>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-button variant="primary" type="submit">{{ formRange.isEditing ? 'Guardar edición' : 'Guardar'}}</b-button>
                  <b-button variant="light" class="btn-sm" @click="$bvModal.hide('range')">Cancelar</b-button>
                </b-form>
              </validation-observer>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <a-divider orientation="left"><strong>Rango de Valoraciones</strong>
            <b-button variant="primary" @click="openCollapse()" style="position: absolute; right: 2rem; top: -0.5em; z-index: 1;">Crear</b-button>
          </a-divider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table v-if="form.assessment.ranges.length > 0" striped hover :fields="visibleFields" :items="form.assessment.ranges" head-variant="light" responsive>
            <template #cell(lose)="data">
              {{ (data.item.lose) ? 'SI' : 'NO' }}
            </template>
            <template #cell(action)="data">
              <button type="button" class="btn btn-outline-secondary mr-2" @click="editRange(data.item)">Editar</button>
              <button type="button" class="btn btn-outline-secondary mr-2" @click="descriptionRange(data.item)">Agregar descripción</button>
              <button type="button" class="btn btn-outline-secondary mr-2" @click="deleteRange(data.item)">Eliminar</button>
            </template>
          </b-table>
          <empty-table v-else/>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import apiClient2 from '@/services/axios/v2'
import { mapState } from 'vuex'
import Swal from 'sweetalert2'
import emptyTable from '@/components/custom/cardEmptyList'
import axios from 'axios'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 8000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

const columns = [
  { title: 'Nombre', dataIndex: 'name', key: 'name' },
  { title: 'Tipo', dataIndex: 'system', key: 'system', scopedSlots: { customRender: 'system' } },
  { title: 'Acción', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } },
]
const rangeColumns = [
  { key: 'name', label: 'Nombre', visible: true },
  { key: 'abbreviation', label: 'Abreviación', visible: true },
  { key: 'start', label: 'Inicio', visible: true },
  { key: 'end', label: 'Final', visible: true },
  { key: 'lose', label: 'Pierde', visible: true },
  { key: 'action', dataIndex: '', scopedSlots: { customRender: 'action' }, visible: true },
]

export default {
  name: 'qualificationRange',
  components: {
    emptyTable,
  },
  data() {
    return {
      form: {
        isEditing: false,
        name: '',
        idQualificationSystem: null,
        min: '',
        max: '',
        assessment: {
          decimal: '',
          approximate: false,
          ranges: [],
        },
      },
      formRange: {
        isEditing: false,
        name: '',
        abbreviation: '',
        description: '',
        start: '',
        end: '',
        lose: false,
        order: null,
      },
      visibleCollapse: false,
      visibleCollapse2: false,
      showDecimalOptions: false,
      data: [],
      limit: 1,
      systemsAvailable: [],
      orderAvailable: [
        { value: null, text: 'Seleccione una opción' },
      ],
      columns,
      rangeColumns,
    }
  },
  computed: {
    ...mapState(['user']),
    visibleFields() {
      return this.rangeColumns.map(field => {
        if (field.key === 'abbreviation') {
          if (this.checkEvaluationSystem(this.form.idQualificationSystem, 'QUALITATIVE')) {
            return field
          }
        } else {
          return field
        }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    function getEvaluationSystems() {
      return apiClient2.get('/evaluationSystems')
    }

    function getAssesments() {
      return apiClient.get('/qualifications/assessments')
    }

    axios.all([getAssesments(), getEvaluationSystems()])
      .then(axios.spread(function (assessment, evaluationSystems) {
        next((vm) => {
          vm.setData(null, assessment.data)
          vm.setDataSystems(null, evaluationSystems.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setData(err, [])
          vm.setDataSystems(err, [])
        })
      })
  },
  watch: {
    'form.idQualificationSystem': function (value) {
      for (const system of this.systemsAvailable) {
        if (system.value === value) {
          this.showDecimalOptions = (system.text === 'QUANTITATIVE')
        }
      }
    },
  },
  methods: {
    setData (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        console.log(data.rows)
        this.data = data.rows
      }
    },
    setDataSystems (err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.systemsAvailable = data.data.map((system) => {
          return {
            value: system.id,
            text: system.name,
          }
        })
        this.systemsAvailable.unshift(
          { value: null, text: 'Seleccione una opción' },
        )
      }
    },
    onHidden() {
      this.form = {
        isEditing: false,
        name: '',
        type: null,
        min: '',
        max: '',
        assessment: {
          decimal: '',
          approximate: false,
          ranges: [],
        },
      }
      this.formRange = {
        isEditing: false,
        name: null,
        description: '',
        abbreviation: null,
        start: null,
        end: null,
        lose: false,
        order: null,
      }
      this.visibleCollapse = false
      this.visibleCollapse2 = false
    },
    onHiddenAssesmentRanges() {
      this.formRange = {
        isEditing: false,
        name: null,
        description: '',
        abbreviation: null,
        start: null,
        end: null,
        lose: false,
        order: null,
      }
      this.$refs.rangeObserver.reset()
      this.visibleCollapse = false
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    getValidationMessage(value) {
      if (value > this.form.max) {
        return 'El campo Final debe ser inferior o igual a ' + this.form.max
      } else if (value < this.form.min) {
        return 'El campo Final debe ser superior o igual a ' + this.form.min
      } else {
        return 'El campo Final debe contener solo valores numéricos válidos'
      }
    },
    checkEvaluationSystem(inputSystem, desired) {
      for (const system of this.systemsAvailable) {
        if (system.value === inputSystem) {
          return system.text === desired
        }
      }
      return false
    },
    save() { // Guarda un grado llamando a la API
      if (!this.form.isEditing) {
        apiClient.post('/qualifications/assessments', this.form).then(response => {
          this.search()
          Toast.fire({
            icon: 'success',
            title: 'Creado exitosamente',
          })
        }).catch(err => {
          this.$notification.success({
            message: 'Ooops ocurrio un error',
            description: showErrorMessage(err),
          })
        })
      } else {
        apiClient.patch('/qualifications/assessments/' + this.form.id, this.form).then(response => {
          this.search()
          Toast.fire({
            icon: 'success',
            title: 'Actualizado exitosamente',
          })
        }).catch(err => {
          this.$notification.success({
            message: 'Ooops ocurrio un error',
            description: showErrorMessage(err),
          })
        })
      }
    },
    saveRange() {
      const formRange = Object.assign({}, this.formRange)
      delete formRange.isEditing
      if (!this.formRange.isEditing) {
        this.form.assessment.ranges.push(formRange)
      } else {
        for (let i = 0; i < this.form.assessment.ranges.length; i++) {
          if (this.form.assessment.ranges[i].id === formRange.id) {
            this.form.assessment.ranges[i] = formRange
          }
        }
      }
      this.form = Object.assign({}, this.form)
      this.save()
      this.checkAvailableOrder()
      this.visibleCollapse = false
      this.visibleCollapse2 = false
      this.$bvModal.hide('assesment')
    },
    editRange(data) {
      if (this.visibleCollapse) {
        this.onHiddenAssesmentRanges()
      } else {
        this.visibleCollapse = true
        this.formRange = data
        this.formRange.isEditing = true
      }
    },
    descriptionRange(data) {
      this.visibleCollapse2 = true
      this.formRange = data
      this.formRange.isEditing = true
    },
    deleteRange(item) {
      console.log(item)
    },
    openCollapse() {
      this.formRange.id = this.limit
      this.visibleCollapse = !this.visibleCollapse
      this.visibleCollapse2 = false
    },
    openModal(level) { // Abre el modal para editar el grado
      if (level !== null) {
        this.form = Object.assign({}, level)
        this.form.isEditing = true
      }
      this.$bvModal.show('assesment')
    },
    checkAvailableOrder() {
      this.limit = (this.form.assessment.ranges.length > 0) ? this.form.assessment.ranges.length + 1 : 1
      this.orderAvailable.length = 1
      for (let i = 1; i <= this.limit; i++) {
        this.orderAvailable.push({ value: i, text: i })
      }
    },
    openModalRange(level) { // Abre el modal para editar el grado
      if (level !== null) {
        this.form = Object.assign({}, level)
        this.form.isEditing = true
        console.log(this.form)
        this.checkAvailableOrder()
      }
      this.$bvModal.show('range')
    },
    search() {
      apiClient.get('/qualifications/assessments').then(response => {
        this.setData('', response.data)
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrio un error',
          description: showErrorMessage(err),
        })
      })
    },
  },
}
</script>
